import '@mdi/font/css/materialdesignicons.css'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import colors from 'vuetify/util/colors'

const baseWeight = "lighten5";
const darkerWeight = "lighten4";
const darkWeight = "darken1";

export default createVuetify({
  components,
  directives,
  defaults: {
    // Global icon size default
    VIcon: {
      size: 18,
    },
    
    // List defaults
    VList: {
      density: 'compact',
      nav: true,  // Adds appropriate padding for navigation lists
    },
    
    VListItem: {
      density: 'compact',
      rounded: 'lg',  // Subtle rounding like Linear
    },
    
    VListSubheader: {
      class: 'linear-list-subheader',
    },
    
    VBtn: {
      variant: 'outlined',  // Secondary is most common, make it default
      rounded: 'md',
      elevation: 0,
      ripple: false,        // Disable Material ripple effect
    },
    
    VTextField: {
      density: 'compact',
    },
    
    VSelect: {
      density: 'compact',
    },
    
    VSnackbar: {
      color: 'white',
      class: 'snackbar-outlined',
    },
    VTooltip: {
      contentClass: 'tooltip-light',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#041708',
          'on-primary': '#FFFFFF',
          'surface-variant': '#F5F5F5',
          secondary: '#cdfc8a',
          accent: '#cdfc8a',
          'surface-light': '#d2cbfe',
          info: '#6B5CE7',  // Purple-tinted info for links and highlights

          catRed: '#ffdede',
          catBlue: '#d2cbfe',
          catGreen: '#cdfc8a',
          catOrange: colors.orange[baseWeight],
          catPurple: '#d2cbfe',
          catTeal: colors.teal[baseWeight],

          catRedDark: '#e31700',
          catBlueDark: '#6B5CE7',
          catGreenDark: '#041708',
          catOrangeDark: colors.orange[darkWeight],
          catPurpleDark: '#5A4BD6',
          catTealDark: colors.teal[darkWeight],

          catWorks: '#d2cbfe',
          catEntity: '#cdfc8a',

          catWorksDarker: '#B8AFFE',
          catEntityDarker: '#b8e878',
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi',
  }
})
